import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../Dashboard";

export const apiKeysRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "api-keys",
}).lazy(() => import("./APIKeys.lazy").then((d) => d.Route));
